export function topicNames(dto, isEnglish) {
  const nameAr = dto.ArabicName ?? ''
  const nameEn = dto.EnglishName ?? ''
  return { name: (isEnglish ? nameEn : nameAr) || nameAr || nameEn, nameAr, nameEn }
}
